"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoryCache = void 0;
const memory_cache_1 = __importDefault(require("memory-cache"));
function memoryCache() {
    return {
        async get(key) {
            return memory_cache_1.default.get(key);
        },
        async set(key, value, { ttl }) {
            if (ttl) {
                memory_cache_1.default.put(key, value, Number(ttl) * 1000);
                return true;
            }
            memory_cache_1.default.put(key, value);
            return true;
        },
        async del(key) {
            memory_cache_1.default.del(key);
            return 1;
        },
        async getOrCreate(key, creator, options) {
            const cachedValue = await this.get(key);
            if (cachedValue)
                return cachedValue;
            const value = await creator();
            await this.set(key, value, options);
            return value;
        },
        async miss(key, value, options) {
            if (await this.get(key))
                return false;
            return this.set(key, value, options);
        },
        async flushAll() {
            memory_cache_1.default.clear();
        },
    };
}
exports.memoryCache = memoryCache;
//# sourceMappingURL=memory-cache.js.map